import { Linkedin, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const EMAIL = "support@anchorsideglobal.com";

export const Footer = () => (
  <footer className="bg-petrol text-parchment relative z-10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-b border-parchment/15 pb-16">
        <div className="md:col-span-6">
          <Logo dark />
          <p className="font-serif italic text-2xl md:text-3xl text-parchment/90 mt-8 max-w-md leading-tight">
            Steady, reliable support — built to last.
          </p>
        </div>
        <div className="md:col-span-3">
          <h4 className="font-sans text-xs uppercase tracking-[0.2em] text-verdigris mb-5">
            Connect
          </h4>
          <a
            href="https://www.linkedin.com/company/anchorside-global/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin"
            className="flex items-center gap-3 font-sans text-parchment/80 hover:text-parchment transition-colors mb-4"
          >
            <Linkedin size={18} /> LinkedIn
          </a>
          <a
            href={`mailto:${EMAIL}`}
            data-testid="footer-email"
            className="flex items-center gap-3 font-sans text-parchment/80 hover:text-parchment transition-colors break-all"
          >
            <Mail size={18} /> {EMAIL}
          </a>
        </div>
        <div className="md:col-span-3">
          <h4 className="font-sans text-xs uppercase tracking-[0.2em] text-verdigris mb-5">
            Legal
          </h4>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="font-sans text-parchment/80 hover:text-parchment transition-colors block mb-4"
          >
            Privacy Policy
          </Link>
          <p className="font-sans text-parchment/60 text-sm leading-relaxed">
            Dedicated offshore paraplanning & back-office teams for UK financial
            advisers.
          </p>
        </div>
      </div>
      <div className="pt-8 flex flex-col md:flex-row justify-between gap-4">
        <span className="font-sans text-sm text-parchment/60">
          © 2026 Anchorside Global. All rights reserved.
        </span>
        <span className="font-sans text-sm text-parchment/60">
          UK Financial Advice · Offshore Teams · India
        </span>
      </div>
    </div>
  </footer>
);
